<template>
  <div class="chartContain">
    <a-spin size="large" v-show="loading" class="loading" />
    <div id="myChart" v-show="!loading"></div>
  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
import { translate } from "@/utils/i18n"
import {depth} from '@/api/wiki'
import {math} from '@/utils/baseFn/math'
import {changeDecimal,numToStr} from '@/utils/baseFn/filter'
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/line');
    require('echarts/lib/component/tooltip');
		import { GridComponent } from 'echarts/components';
		echarts.use([GridComponent]);
    export default {
        name: 'hello',
        data() {
            return {
              loading:true,
							myChart:null,
							loadingType:false,
							setIntervalDom:null,
							updateTime:'3000',
              options:{
                    animation: false,
										grid:{
											top:"50px",
											left:"0px",
											right:"50px",
											bottom:"50px"
										},
                    tooltip: {
                        trigger: 'axis',
                        confine: true,
                        showContent: false,
                        axisPointer: {
                            lineStyle: {
                                // color: '#ffffff',
                                color: 'rgba(0, 0, 0, 0)',
                            }
                        },
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        // inverse:true,
                        axisLabel: {
                            showMinLabel: false,
                            textStyle:{
                              fontSize:10
                            },
                            formatter: function (val) {
                                return '' + changeDecimal(val,2)
                            }
                        },
                    },
                    yAxis: [
                        {
                            type: 'value',
                            position: 'right',
                            splitNumber: 4,
                            axisTick: {
                                inside: true,
                            },
                            axisLabel: {
                                inside: true,
                                showMinLabel: true,
                                textStyle:{
                                  fontSize:10
                                },
                            },
                            axisLine:{
                              lineStyle:{
                                // color:'#fff',
                                // width:2
                              }
                            },
                            splitLine: {
                                show: false,
                            }
                        }
                    ],
                    series: [
                        {
                            data: [],
                            type: 'line',
                            symbol: 'circle',
                            showSymbol: false,
                            symbolSize: 10,
                            itemStyle: {
                                color: 'blue',
                                borderColor: 'yellow',
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                                shadowBlur: 10
                            },
                            label: {
                                show: true,
                                position: 'right',
                                distance: 0,
                                padding: 10,
                                fontSize: 12,
                                color: '#fff',
                                backgroundColor: 'rgba(0, 0, 0, .6)',
                                formatter: function (params) {
                                    return [` ${translate('14007')}:{a|${params.data[0]}}`, `${translate('12945')}:{a|${Math.round(params.data[1])}}`].join('\n')
                                },
                                rich: {
                                    a: {
                                        color: '#fff',
                                        fontSize: '12',
                                        fontWeight: 'bold',
                                        lineHeight: '20',
                                    },
                              
                                }
                            },
                            lineStyle: {
                                color:'#008c00',
                            },
                            areaStyle: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                                [
                                {offset: 0, color: 'rgb(107, 185, 109,0.5)'},
                                    {offset: 0.25, color: 'rgb(107, 185, 109,0.4)'},
                                    {offset: 0.5, color: 'rgb(107, 185, 109,0.3)'},
                                    {offset: 0.75, color: 'rgb(107, 185, 109,0.2)'},
                                    {offset: 1, color: 'rgb(107, 185, 109,0.1)'},
                                ])
                            },
                        },
                        {
                            data: [],
                            type: 'line',
                            symbol: 'circle',
                            showSymbol: false,
                            symbolSize: 10,
                            itemStyle: {
                                color: 'blue',
                                borderColor: 'yellow',
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                                shadowBlur: 10
                            },
                            label: {
                                show: true,
                                position: "left",
                                distance: 0,
                                padding: 10,
                                fontSize: 12,
                                color: '#fff',
                                backgroundColor: 'rgba(0, 0, 0, .6)',
                                formatter: function (params) {
                                    return [`${translate('14007')} ：{a|${params.data[0]}}`, `${translate('12945')} ：{a|${Math.round(params.data[1])}}`].join('\n')
                                },
                                rich: {
                                    a: {
                                        color: '#fff',
                                        fontSize: '12',
                                        fontWeight: 'bold',
                                        lineHeight: '20',
                                    },
                                }
                            },
                            lineStyle: {
                                color:'#ee3523',
                            },
                            areaStyle: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                                [
                                    {offset: 0, color: 'rgb(236, 77, 92,0.5)'},
                                    {offset: 0.25, color: 'rgb(236, 77, 92,0.4)'},
                                    {offset: 0.5, color: 'rgb(236, 77, 92,0.3)'},
                                    {offset: 0.75, color: 'rgb(236, 77, 92,0.2)'},
                                    {offset: 1, color: 'rgb(236, 77, 92,0.1)'},
                                ])
                            },
                        },
                    ]
                }
            }
        },
  computed: {
    ...mapState(['excnInfo','trade','symbol','depthData','isLine','country','upDown','tickSize']),
    
  },
watch: {

  isLine:{
    immediate:true,
    handler(e,){
      if(e===false){
        if (this.myChart != null && this.myChart != "" && this.myChart != undefined) {
          this.myChart.dispose();
        }
        setTimeout(() => {
          this.drawLine()
        this.getListDate(this.symbol,this.country)
        window.addEventListener('resize', this.handleWindowResize);
        }, 0);
        }else{
        this.loading=true
        this.destroyed()
        if(this.myChart){
          this.myChart.dispose()
          this.myChart=null
        }}
    }
  },
  symbol(newData){
    if(this.isLine===false){
      this.loading=true
      this.getListDate(newData,this.country)
    }
  },
},
mounted() {
    // this.$nextTick(() => {
    //   // console.log(this.myChart)
    //   if (this.myChart != null && this.myChart != "" && this.myChart != undefined) {
    //     this.myChart.dispose();
    //   }

    //   this.drawLine()
    //   this.getListDate(this.symbol,this.country)
    //   window.addEventListener('resize', this.handleWindowResize);

    // })

},
  methods: {
    ...mapActions(['setIsLine']),
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(document.getElementById('myChart'));
      // 绘制图表
      if(this.upDown===0){
        this.options.series[0].areaStyle.color=new echarts.graphic.LinearGradient(0, 0, 0, 1,
                                [
                                    {offset: 0, color: 'rgb(236, 77, 92,0.5)'},
                                    {offset: 0.25, color: 'rgb(236, 77, 92,0.4)'},
                                    {offset: 0.5, color: 'rgb(236, 77, 92,0.3)'},
                                    {offset: 0.75, color: 'rgb(236, 77, 92,0.2)'},
                                    {offset: 1, color: 'rgb(236, 77, 92,0.1)'},
                                ])
         
        this.options.series[1].areaStyle.color=new echarts.graphic.LinearGradient(0, 0, 0, 1,
                                [
                                {offset: 0, color: 'rgb(107, 185, 109,0.5)'},
                                    {offset: 0.25, color: 'rgb(107, 185, 109,0.4)'},
                                    {offset: 0.5, color: 'rgb(107, 185, 109,0.3)'},
                                    {offset: 0.75, color: 'rgb(107, 185, 109,0.2)'},
                                    {offset: 1, color: 'rgb(107, 185, 109,0.1)'},
                                ])
        this.options.series[1].lineStyle.color='#008c00'
        this.options.series[0].lineStyle.color='#ee3523'

      }else if(this.upDown===1){
        this.options.series[1].areaStyle.color=new echarts.graphic.LinearGradient(0, 0, 0, 1,
                                [
                                    {offset: 0, color: 'rgb(236, 77, 92,0.5)'},
                                    {offset: 0.25, color: 'rgb(236, 77, 92,0.4)'},
                                    {offset: 0.5, color: 'rgb(236, 77, 92,0.3)'},
                                    {offset: 0.75, color: 'rgb(236, 77, 92,0.2)'},
                                    {offset: 1, color: 'rgb(236, 77, 92,0.1)'},
                                ])
        this.options.series[0].areaStyle.color=new echarts.graphic.LinearGradient(0, 0, 0, 1,
                                [
                                {offset: 0, color: 'rgb(107, 185, 109,0.5)'},
                                    {offset: 0.25, color: 'rgb(107, 185, 109,0.4)'},
                                    {offset: 0.5, color: 'rgb(107, 185, 109,0.3)'},
                                    {offset: 0.75, color: 'rgb(107, 185, 109,0.2)'},
                                    {offset: 1, color: 'rgb(107, 185, 109,0.1)'},
                                ])
        this.options.series[0].lineStyle.color='#008c00'
        this.options.series[1].lineStyle.color='#ee3523'
      }
      let that=this
      this.options.xAxis.axisLabel.formatter=function (val) {
        return '' + changeDecimal(val,that.tickSize)
       }
       this.options.series[0].label.formatter=function (val){
        return [`${translate('14007')}：{a|${changeDecimal(val.data[0],that.tickSize)}}`,`${translate('12945')}：{a|${Math.round(val.data[1])}}`].join('\n')
       }
       this.options.series[1].label.formatter=function (val){
        return [`${translate('14007')}：{a|${changeDecimal(val.data[0],that.tickSize)}}`,`${translate('12945')}：{a|${Math.round(val.data[1])}}`].join('\n')
       }
      this.myChart.setOption( this.options);
    }, 
    handleWindowResize () {
      if (!this.myChart) return;
      this.myChart.resize();
    },
    //请求接口获取数据
    getListDate(symbol,country){
      this.loadingType = true
      //判断是否有定时器存在，如果存在先销毁再创建
      if(this.setIntervalDom){
        clearInterval(this.setIntervalDom)
        this.setIntervalDom = ""
      }
      this.getDataFun(symbol,country)
      this.setIntervalDom = setInterval(() => {
        this.getDataFun(symbol,country)
      },this.updateTime)
    },
		getDataFun(symbol,country){

      let params = {
        symbol:symbol.toUpperCase(),
        limit:1000
        // type:0
      }
      depth(params,country).then(result=>{
        if(result){

          this.dealDate(result)
          this.loading=false
        }else{
          this.loadingType = false
        }
        
      }).catch((err) => {
        this.loadingType = false
      })

    },
    //数据处理
    dealDate(list){
      //优化数据
      let datas = {}
      datas.asks = list.asks
      datas.bids = list.bids
      if(this.isOptimizeData && list.asks.length > 1 && list.bids.length > 1){
        datas = this.localDate(list)
      }
      // datas.bids.reverse()
      //对买卖盘数据进行y轴数据的累加
      datas = this.getYnum(datas)
      // datas.bids.reverse()
      // datas.bids.length = 0
      //处理买卖盘画图的点
      //得到x轴坐标和y轴坐标数据
      datas.bids.push([
          datas.bids[datas.bids.length-1][0]-datas.bids[datas.bids.length-2][0],0
        ])
      datas.asks.unshift([
          datas.asks[1][0]-datas.asks[0][0],0
        ])
        var addBid=datas.bids[0]
        var addAsk=datas.asks[datas.asks.length-1]
        let num=datas.asks.length-datas.bids.length
        if(num>0){
          for(let i=0;i<num;i++){
            datas.bids.unshift([
            // numToStr(addBid[0]) + numToStr(i*0.000000001),
            addBid[0]+(i*0.01),
            // 0,
            addBid[1]
            ])
          }
          
        }else if(num<0){
          for(let i=0;i<Math.abs(num) ;i++){
            datas.asks.push([
            addAsk[0]+(i*0.01),
            addAsk[1]
            ])
          }
        }
        // console.log(datas.asks);
        this.options.series[0].data=datas.bids
        this.options.series[1].data=datas.asks
        this.myChart.setOption(this.options,true );
			// this.drawLine(datas)
      // this.init(this.buyDate,this.sellDate,this.xAxisList,this.yAxisList)

    },
    //本地处理数据
    localDate(list){
      //bids--买盘   asks--卖盘

      //去重
      let result = {}
      result.asks = list.asks
      result.bids = list.bids
      // result.asks = this.noRepeat(list.asks)
      // result.bids = this.noRepeat(list.bids)
      
      //排序
      result.asks.sort(function(a, b){return a[0] - b[0]});
      result.bids.sort(function(a, b){return a[0] - b[0]});
      
      //根据买卖盘数据，截取合适的区间数据，以数据小区间为准
      let bids_interval = math.floatSub(result.bids[result.bids.length - 1][0], result.bids[0][0]) //买盘数据差
      let asks_interval = math.floatSub(result.asks[result.asks.length - 1][0], result.asks[0][0]) //卖盘数据差
      
      let res = {}
      if(bids_interval > asks_interval){ //截取买盘数据
        let allNum = math.floatAdd(asks_interval, result.bids[0][0])
        
        res.asks = result.asks
        res.bids = result.bids.filter((item) => allNum > Number(item[0]))
        
        let before = math.floatSub(allNum, res.bids[res.bids.length-1][0])
        let after  = math.floatSub(result.bids[res.bids.length][0],allNum)

        if(before > after){
          res.bids.push(result.bids[res.bids.length])
        }

      }else{                             //截取卖盘数据
        let allNum = math.floatAdd(bids_interval, result.asks[0][0])

        res.asks = result.asks.filter((item) => allNum > Number(item[0]))
        res.bids = result.bids
        
        let before = math.floatSub(allNum, res.asks[res.asks.length-1][0])
        let after  = math.floatSub(result.asks[res.asks.length][0],allNum)

        if(before > after){
          res.asks.push(result.asks[res.asks.length])
        }
        
      }
      
      return res
    },
    //数组去重
    noRepeat(arr){
      let obj={};
      let arr2=[];
      for(let i=0;i<arr.length;i++){
          if(!obj[arr[i][0]]){
              obj[arr[i][0]]=true;
              arr2.push(arr[i]);
          }
      }
      return arr2
    },
    //对买卖盘数据进行y轴数据的累加
    getYnum(datas){
      let arr = []
      if(datas.bids.length > 0){
        
        datas.bids
        arr.bids = this.addNum(datas.bids).reverse()
      }else{
        arr.bids = []
      }
      if(datas.bids.length > 0){
        arr.asks = this.addNum(datas.asks)
      }else{
        arr.asks = []
      }
      return arr
    },
    //对数据累加，并返回数组
    addNum(lists){
      let allNum = 0
      let newArr = []
      lists.map((item) => {
        allNum = math.floatAdd(allNum, item[1])
        newArr.push([item[0],allNum])
      })
      return newArr
    },
  destroyed() {
    
    //销毁定时器
    if(this.setIntervalDom){
      clearInterval(this.setIntervalDom)
      this.setIntervalDom = ""
    }
  },

  },
	beforeDestroy() {
		// this.setIsLine({isLine:true})
    if (!this.myChart) {
      return
    }
    this.myChart.dispose()
    this.myChart = null
		this.destroyed()
	},
    }
</script>
<style lang="less" scoped>
.chartContain{
  width: 100%;
  height: calc(100vh - 160px);
  .loading{
          display: flex;
          height: 100%;
          width: 100%;
          justify-content: center;
          align-items: center;
        }
  #myChart{
    // width: 100vw;
    width: calc(100vw - 800px);
    height: calc(100vh - 160px);
  }
}
</style>